"use client";

interface DailyProgressProps {
  readonly completedCount: number;
  readonly totalCount?: number;
  readonly compact?: boolean;
}

export default function DailyProgress({ completedCount, totalCount = 2, compact = false }: DailyProgressProps) {
  const radius = compact ? 34 : 40;
  const stroke = compact ? 5 : 6;
  const normalizedRadius = radius - stroke;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (Math.min(completedCount, totalCount) / totalCount) * circumference;

  return (
    <div className="daily-stat-item anim-fade-in" style={{ gap: compact ? "8px" : "12px" }}>
      <div className="progress-ring-container" style={{ width: `${radius * 2}px`, height: `${radius * 2}px`, position: "relative" }}>
        <svg height={radius * 2} width={radius * 2}>
          <circle
            stroke="var(--border-color)"
            fill="transparent"
            strokeWidth={stroke}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
          <circle
            fill="transparent"
            strokeWidth={stroke}
            strokeDasharray={circumference + " " + circumference}
            style={{ strokeDashoffset, stroke: "var(--primary)" }}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
            className="progress-ring-circle"
          />
        </svg>
        <span
          className="progress-ring-text"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            fontSize: compact ? "0.85rem" : "1.15rem",
            fontWeight: "var(--fw-extrabold)",
            lineHeight: 1,
            margin: 0,
            whiteSpace: "nowrap"
          }}
        >
          {completedCount}/{totalCount}
        </span>
      </div>
      {!compact && (
        <div className="daily-stat-info">
          <span className="daily-stat-num">{completedCount}</span>
          <span className="daily-stat-label">Tasks Done</span>
        </div>
      )}
    </div>
  );
}
